import { repositoryFetch } from 'shared/repositories/repositoryFetch';

export const axilSeriesByDateEndpoint = '/v4/axil/series/hot/by_date';

export const fetchSeriesByDate = (accessToken, body) => repositoryFetch({
  accessToken,
  body,
  endpoint: axilSeriesByDateEndpoint,
});
